import axiosInstance from "../lib/axios";

interface GetCategoryRequest {
  page?: number;
  limit?: number;
}

export const getCategory = async ({
  page = 1,
  limit = 10,
}: GetCategoryRequest) => {
  const body = {
    page,
    limit,
  };

  const { data } = await axiosInstance.post("/Category/List", body);

  return data;
};

export const createCategory = (data: {
  category_name: string;
  status: string;
}) => {
  return axiosInstance.post("/Category/Create", data);
};

export const getCategoryById = (id: number) => {
  return axiosInstance.get(`/Category/${id}`);
};

export const editCategory = (id: number, data: any) => {
  return axiosInstance.put(`/Category/${id}`, data);
};

export const deleteCategoryById = (id: number) => {
  return axiosInstance.delete(`/Category/${id}`);
};

